module.exports = __webpack_public_path__ + "static/media/Fitmonkie_4_Laid-Back-Days Biker Shorts .eb7ea548.png";